import { render, staticRenderFns } from "./SmoothCarousel.vue?vue&type=template&id=352c3b40&scoped=true&"
import script from "./SmoothCarousel.vue?vue&type=script&lang=js&"
export * from "./SmoothCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SmoothCarousel.vue?vue&type=style&index=0&id=352c3b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c3b40",
  null
  
)

export default component.exports